export default "__VITE_ASSET__jMX3E0gh__"